import {
  createProgressiveFormGroupState,
  createProgressiveNgrxFormReducerWithFormStateUpdate,
  type ProgressiveFormStateImplementor,
} from '@innogy/progressive-ngrx-forms';
import type {
  ChargePointType,
  MountType,
  ProductColor,
} from '@integration/api-client/emobility';
import type { Action } from '@ngrx/store';
import { updateGroup, validate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';

export interface ChargePointConfigurationFormState {
  chargePointType: `${ChargePointType}` | undefined;
  productColor: `${ProductColor}` | undefined;
  fixedCable: boolean | undefined;
  mountType: `${MountType}` | undefined;
  interestedInReimbursement: boolean;
  numberOfStations: number;
}

export interface ChargePointConfigurationState
  extends ProgressiveFormStateImplementor<ChargePointConfigurationFormState> {}

export const chargePointConfigurationFormId =
  'emobility-lead-charge-point-configuration';

export const chargePointColorControlId = `${chargePointConfigurationFormId}.productColor`;
export const chargePointTypeControlId = `${chargePointConfigurationFormId}.chargePointType`;
export const chargePointFixedCableControlId = `${chargePointConfigurationFormId}.fixedCable`;

const chargePointConfigurationInitialState =
  createProgressiveFormGroupState<ChargePointConfigurationFormState>(
    chargePointConfigurationFormId,
    {
      chargePointType: undefined,
      productColor: undefined,
      fixedCable: undefined,
      mountType: undefined,
      interestedInReimbursement: false,
      numberOfStations: 1,
    }
  );

export const initialChargePointConfigurationState: ChargePointConfigurationState =
  {
    progressiveForm: chargePointConfigurationInitialState,
  };

export const validateChargePointConfigurationForm = (
  state: ChargePointConfigurationState
) => {
  return updateGroup(state.progressiveForm.formState, {
    chargePointType: validate(required),
    productColor: validate(required),
    fixedCable: validate(required),
    mountType: validate(required),
    numberOfStations: validate(required),
  });
};

export const _reducer = createProgressiveNgrxFormReducerWithFormStateUpdate(
  initialChargePointConfigurationState,
  validateChargePointConfigurationForm
);

export function chargePointConfigurationReducer(
  state = initialChargePointConfigurationState,
  action: Action
) {
  return _reducer(state, action);
}
